import { NumericFormat, NumericFormatProps } from "react-number-format";
import React from "react";
interface CustomProps {
  onChange: (event: { target: { name: string; value: number } }) => void;
  name: string;
}
export const NumericFormatToman = React.forwardRef<NumericFormatProps, CustomProps>(function NumericFormatCustom(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      type="tel"
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: (values.floatValue as number) ?? null,
          },
        });
      }}
      allowNegative={false}
      thousandSeparator={","}
      thousandsGroupStyle={"none"}
      valueIsNumericString={false}
      allowLeadingZeros={false}
    />
  );
});
